/**
 * Select an integer representation for follower counts
 */
Beef.module("ReachPicker").addInitializer(function(startupOptions) {

    this.View = Beef.IntegerPicker.View.extend({
        attribute: 'Total Reach'
    });

    this.converter = Beef.IntegerPicker.createConverter("Total Reach");

    this.attach = function(view, selector, attribute, options) {
        Beef.IntegerPicker.attachPicker(view, selector, attribute, this.View, options);
    };

});
